// @flow
import type { Action } from '../actions/error';

export type State = ?Error;

export default function error(state: State = null, action: Action) {
  switch (action.type) {
    case 'SET_ERROR':
      return action.error;
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
